








































import {Component, Prop, Vue} from 'vue-property-decorator'
import Cookies from 'js-cookie'
import _ from 'lodash'
import {wt} from '@/api'
@Component({
    name: 'changePwd'
})
export default class changePwd extends Vue{
  public $refs!: {
      formData: HTMLFormElement;
  }
  visible: boolean = false;

  private formData: any = {
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
  };
  public wrong: any = {
      oldPwd: false,
      oldPwd1: false,
      newPwd0: false,
      newPwd1: false,
      conPwd: false,
      twicePwd: false
  }
  private classList:any = {
      oldClass: '',
      newClass: '',
      conClass: '',
  }

  async created(){}

  focusBlur(type:any){
      if(type=='oldPwd'){
          if(!this.formData.oldPwd){
              this.wrong.oldPwd = true
              this.classList.oldClass = 'wrong-old'
          }
          else{
              this.wrong.oldPwd = false
              this.classList.oldClass = 'success-old'
          }
      }
      else if(type=='newPwd'){
          let regs = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,30}$/  //正则表达式
          let flag = regs.test(this.formData.newPwd)
          if(!this.formData.newPwd){
              this.wrong.newPwd0 = true
              this.wrong.newPwd1 = false
              this.classList.newClass = 'wrong-new'
          }
          else{
              this.wrong.newPwd0 = false
              if(!flag){
                  this.wrong.newPwd1 = true
                  this.classList.newClass = 'wrong-new'
              }
              else{
                  this.wrong.newPwd1 = false
                  this.classList.newClass = 'success-new'
              }
          }
      }
      else if(type=='confirmPwd'){
          if(!this.formData.confirmPwd){
              this.wrong.twicePwd = true
              this.wrong.conPwd = false
              this.classList.conClass = 'wrong-confirm'
          }
          else{
              this.wrong.twicePwd = false
              if(this.formData.newPwd!=this.formData.confirmPwd){
                  this.wrong.conPwd = true
                  this.classList.conClass = 'wrong-confirm'
              }
              else{
                  this.wrong.conPwd = false
                  this.classList.conClass = 'success-confirm'
              }
          }
      }
  }

  async submit(){
      let flag = false
      for(let i in this.formData){
          if(!this.formData[i]){
              this.focusBlur(i)
              flag = true
          }
      }
      for(let key in this.wrong){
          if(this.wrong[key]){
              flag = true
          }
      }
      if(flag){
          return
      }
      let list = { 
          oldPassWord: this.formData.oldPwd,
          newPassWord: this.formData.newPwd
      }
      let data = await wt.Identity_ChangePwd(list)
      if(data.Success){
          this.$message({
              showClose: true,
              message: '密码修改成功，请重新登录！',
              type: 'success'
          });
          Cookies.remove('loginPwd')
          this.$router.push('./login')
      }
  }

  async open(){
      this.visible = true
  }

  handleClose(){
      this.visible = false
      for(let key in this.wrong){
          this.wrong[key] = false
      }
      for(let i in this.formData){
          this.formData[i] = ''
      }
      for(let i in this.classList){
          this.classList[i] = ''
      }
      this.$emit('showDiag', false);
  }
}
